import React from 'react'
import { useExplorer } from '../../../context/explorer'
import { Summary } from '../../Summary/Summary'

/**
 * Bridge component for Explorer.
 * Consumes ExplorerContext and passes props to Summary.
 *
 * This keeps Summary pure and context-free, allowing it to be reused
 * across the app (Chat, Canvas, Slack) with different data sources.
 *
 * @param {Object} props
 * @param {Function} props.onChartClick - Optional callback for chart element clicks
 * @param {Function} props.onDrill - Optional callback for drill-down actions
 */
export const ExplorerSummary = ({ onChartClick, onDrill }) => {
    const {
        chartOptions,
        summaryData,
        viewConfig,
        isLoading,
        isFetching,
        error,
        hasData,
        hasSelectedItems,
    } = useExplorer()

    // Determine view type from viewConfig
    const view = viewConfig?.view || 'chart'

    // Calculate height based on window size
    const height = `${window.innerHeight - 112 - 64}px`

    return (
        <Summary
            // Data props
            chartOptions={chartOptions}
            tableData={summaryData}
            kpiData={summaryData}
            view={view}
            // Status props
            isLoading={isLoading || isFetching}
            error={error}
            hasData={hasSelectedItems && hasData}
            // Display props
            height={height}
            clickable
            onChartClick={onChartClick}
            onDrill={onDrill}
        />
    )
}
